<template>
  <div class="rootContainer" @mouseleave="stopPreviewItem">
    <searchBar class="searchBar" searchType="17" @search="onSearch"></searchBar>

    <div ref="topBarDom" class="top-bar-container">
      <filterMenu
        title="类型"
        displayName="name"
        v-model="classify"
        :filtersContent="classifyFlags"
        @selectChanged="classifyChanged"
      ></filterMenu>

      <div v-show="!keyWord && classify && classify.id">
        <filterMenu
          title="分类"
          displayName="name"
          v-model="category"
          :filtersContent="categorys"
          :openShowMoreBtn="true"
          @selectChanged="categoryChanged"
        ></filterMenu>
      </div>

      <div class="fixed-filter-container">
        <div>
          <filterMenu
            title="排序"
            displayName="name"
            v-model="sort"
            :filtersContent="sortFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="价格"
            displayName="name"
            v-model="price"
            :filtersContent="resourceLevelOptions2"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="授权"
            displayName="name"
            v-model="commerical"
            :filtersContent="commericalFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <styleMenu
          class="style-layout"
          v-model="currentStyle"
          :menuList="StyleArrayMsg"
          @selectChange="onStyleChange"
        ></styleMenu>
      </div>
    </div>

    <div
      class="content-container"
      ref="contentcontainer"
      @scroll="handleScroll"
    >
      <ul class="content-list">
        <li
          v-for="(item, index) in contentList"
          :key="index"
          @mouseenter="startPreviewItem(item, index)"
          @mouseleave="stopPreviewItem(item, index)"
        >
          <div class="li-item-container" @click="addToCanvas(item)">
            <!-- 封面、普通素材、gif-->
            <img
              :ref="'img' + index"
              v-if="item.fileType != 42"
              class="static-cover"
              :src="$handleAssetsUrl(item.thumbnailUrl)"
            />
            <!-- lottie -->
            <div
              v-if="
                item.fileType == 5 || item.fileType == 8 || item.fileType == 9
              "
              :ref="'lottie' + index"
              class="lottie-cover"
            ></div>

            <!-- 视频 -->
            <video
              :ref="'video' + index"
              v-if="item.fileType == 42"
              class="video-cover"
              :src="$handleAssetsUrl(item.thumbnailUrl)"
              loop="loop"
            ></video>

            <!-- <div class="addbtn" @click="addToCanvas(item)" @click.stop>添加到画布</div> -->
            <!-- <div v-if="item.payType == 4" class="vip-logo"></div>
            <div
              v-if="
                (UserMsg.payForMaterial != 1 && item.payType == 1) ||
                item.payType == 2 ||
                item.payType == 3
              "
              class="price-style"
            >
              {{ item.tt ? "已购买" : "￥" + item.price }}
            </div> -->
            <payType-subscript
              :item="item"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>
          </div>
          <div class="logo-container">
            <div v-if="item.companyIcon" class="company-logo">
              <img :src="$handleAssetsUrl(item.companyIcon)" />
              <div class="company-arrow-box">
                <span>{{ item.company }}</span>
              </div>
            </div>
            <div v-show="item.isCommerical" class="commerical-logo"></div>
            <div class="favorites-bg" @click="favoriteItem(item)" @click.stop>
              <div
                class="favorites-state"
                :class="[
                  item && item.favorites ? 'already-favorites' : 'no-favorites',
                ]"
              ></div>
            </div>
          </div>
        </li>
      </ul>
      <div class="loading">
        <Loading
          :loading="loadingStatus == 1"
          v-show="loadingStatus == 1"
        ></Loading>
        <div v-show="loadingStatus == 2">没有更多内容了哦</div>
      </div>
    </div>

    <!-- <p v-if="loading">加载中...</p>
    <p v-if="noMore">没有更多了</p>-->
    <isEmptyResult
      v-if="loadingStatus == 2 && contentList.length == 0"
    ></isEmptyResult>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import searchBar from "../searchBar";
import styleMenu from "../dropDownMenu";
import filterMenu from "../filterMenu";
import isEmptyResult from "../isEmptyResult";
import baseContent from "./baseContent.vue";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import Loading from "@/components/emodal/templateLib/loading";

export default {
  mixins: [baseContent],
  name: "propsContent",
  data() {
    return {
      type: 17,
      //记录条件筛选
      classify: null,

      classifyFlags: [{ id: null, name: "全部" }],
      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        { name: "付费", value: "&payType=1,2,3" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],
      previewTimer: null,
      lottiedata: null, // 播放lottie
      videoDom: null, //有声素材

      categoryId: "",
    };
  },
  props: {},
  components: {
    searchBar,
    styleMenu,
    filterMenu,
    isEmptyResult,
    PayTypeSubscript,
    Loading,
  },
  methods: {
    ...mapActions({
      matchType: 'resources/matchType'
    }),
    //道具的分类比较特殊，必须先查询类型在获取分类
    async getCategorys() {
      if (this.classifyFlags.length <= 1) {
        this.classifyFlags = await this.getClassifys();
      }
    },

    //获取类型数据
    getClassifys() {
      let url = "/api/home/category?type=17&categoryType=1";
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      let classifyList = [{ id: null, name: "全部" }];
      return this.$http
        .get(url)
        .then((res) => {
          let data = [];
          for (const key in res.data.data) {
            data.push(res.data.data[key]);
          }
          data = data.sort(function (a, b) {
            return b.power - a.power;
          });
          for (const key in data) {
            classifyList.push(data[key]);
          }
          return classifyList;
        })
        .catch((error) => {
          return classifyList;
        });
    },

    //获取分类信息
    async getPropCategorys() {
      let requestBody = {
        type: this.type,
        // style: this.currentStyle.id,
      };
      if (this.classify && this.classify.id) {
        requestBody.categoryId = this.classify.id;
        if (this.classify.originalType) {
          requestBody.type = this.classify.originalType;
        }
      }
      let response = await this._getCategorys(requestBody);
      let matched = await this.matchType(('' + this.classify.fileType || '').split(','))
      const mapped = matched.map(({name, type = []}) => {
        return {
          name,
          fileType: type.join(',')
        }
      }) || [];
      this.categorys = [{ id: null, name: "全部" }, ...mapped];
      // if (response) {
      //   for (let i = 0; i < response.length; i++) {
      //     if (response[i].id == 141336) {
      //       response.splice(i, 1);
      //       i--;
      //     }
      //   }
      //   this.categorys = [{ id: null, name: "全部" }].concat(response);
      // }
    },

    //重置类型选项
    resetFilter(navParam) {
      if (navParam) {
        this.categoryId = navParam.category;

        if (this.classify && this.classify.id === navParam.classify) {
          this.resetCategoryFilter(this.categoryId);
          return;
        }

        let findClassify = this.findFirstById(
          this.classifyFlags,
          navParam.classify
        );
        if (findClassify) {
          this.classify = findClassify;
        } else {
          this.classify = this.classifyFlags[0];
        }
      } else {
        this.categoryId = "";
        if (!this.classify) {
          this.classify = this.classifyFlags[0];
        }
      }
    },

    resetCategoryFilter(id) {
      if (id) {
        let findCategory = this.findFirstById(this.categorys, id);
        if (findCategory) {
          this.category = findCategory;
        } else {
          this.category = this.categorys[0];
        }
      } else {
        this.category = this.categorys[0];
      }
    },

    //当类型发生改变时，重新获取分类信息
    async classifyChanged(newValue, oldValue) {
      await this.getPropCategorys();
      this.resetCategoryFilter(this.categoryId);
    },

    categoryChanged() {
      this.categoryId = this.category.id;
      this.fileType = this.category.fileType;
      this.refreshContentList();
    },

    getContentList: function () {
      this.loadingStatus = 1;
      let url =
        "/api/common/material?fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex;

      if (this.classify && this.classify.originalType) {
        url += "&type=" + this.classify.originalType;
      } else {
        url += "&type=17";
      }

      if (this.category && this.category.id != null) {
        url += "&category=" + this.category.id;
      } else if (this.classify && this.classify.id != null) {
        url += "&category=" + this.classify.id;
      }
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      if (this.fileType) {
        url += "&fileType=" + this.fileType;
      }
      if (this.sort) {
        url += this.sort.value;
      }
      if (this.price) {
        url += this.price.value;
      }
      if (this.commerical) {
        url += this.commerical.value;
      }
      if (
        typeof this.keyWord != "undefined" &&
        this.keyWord != null &&
        this.keyWord != ""
      ) {
        url += "&keyword=" + this.keyWord;
      }
      this.setTrackingData(url);

      //console.log(this.secondClassify);
      this.$http
        .get(url)
        .then((res) => {
          if (this.keyWord) {
            let order_methods = {
              "": "推荐",
              "&orderBy=2": "最新",
            };
            let choose_prices = {
              "": "全部",
            "&payType=0": "免费",
            "&payType=4": "会员专属",
            "&payType=1,2,3": "付费",
            "&payType=6": "企业会员专属"
            };
            sensors.track("classifySearchResult", {
              search_source: "编辑器素材弹窗",
              keyword: this.keyWord,
              has_result: !!(res.data.data && res.data.data.length),
              material_type: "道具",
              search_type: "素材搜索",
              search_result_num: res.data.data.length,
              keyword_type: this.trackingData.keyword_type || "手动输入",
              order_method: this.sort ? order_methods[this.sort.value] : "推荐",
              choose_price: this.price
                ? choose_prices[this.price.value]
                : "全部",
            });
          }
          // console.log("获取道具：" + JSON.stringify(res.data));
          //this.totalCount = res.data.total;
          if (!this.contentList) {
            this.contentList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }
          if (res.data.total <= this.contentList.length) {
            this.loadingStatus = 2;
          } else {
            this.loadingStatus = 0;
          }
        })
        .catch((res) => {
          //console.log("获取数据失败");
          this.loadingStatus = 0;
        });
    },
    addToCanvas: function (item) {
      let categoryId = (item.gifCategory || item.shapeCategory || {}).categoryId || '';
      // let classifyOfItem = this.classifyFlags.find(v => v.id === categoryId) || {};
      let originalType = item.gifCategory ? 37 : (item.shapeCategory ? 15 : 17);
      this.$bus.emit('beforeAddToCanvas', {data: item, type: originalType || 'material'});
      this.trackSearchResultClick(item);
      if (!item.fileType) {
        let fileType = item.url.split(".")[1];
        item.fileType = fileType;
      }

      const isGif = (name) => /\.gif$/i.test(name);
      const gifOrImage = (name) => (isGif(name) ? "Gif" : "Image");

      switch (item.fileType) {
        case 3: // png/jpg/jpeg--道具
        case 6: // png/jpg/jpeg--形状
        case 18: // png/jpg/jpeg--图片
        case "PNG":
        case "png":
        case "JPG":
        case "jpg":
        case "JPEG":
        case "jpeg":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: gifOrImage(item.url),
                optionForAdd: {
                  source: item.source,
                  url: item.url,
                  resourceId: item.id, // 资源id
                  fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              gifOrImage(item.url),
              {
                source: item.source,
                url: item.url,
                resourceId: item.id,
                fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                isLoop: false,
                effectCode: "FadeIn",
              },
              null,
              true
            );
          }
          break;
        case 32:
        case 33:
        case 34:
        case "GIF":
        case "gif":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            if (sprite.type === "Video") {
              sprite.isLoop = sprite.video.loop;
              sprite.numberOfLoops = sprite.video.repeatTimes;
            }

            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: gifOrImage(item.url),
                optionForAdd: {
                  source: item.source,
                  url: item.url,
                  resourceId: item.id, // 资源id
                  fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                  isLoop:
                    typeof sprite.isLoop === "boolean"
                      ? sprite.isLoop
                      : sprite.option.isLoop,
                  numberOfLoops: sprite.numberOfLoops,
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              gifOrImage(item.url),
              {
                source: item.source,
                url: item.url,
                resourceId: item.id || uuid.generate(),
                fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                effectCode: "FadeIn",
              },
              null,
              true
            );
          }
          break;
        case 4: // svg--道具
        case 7: // svg--形状
        case 12: // svg--文字
        case 19: // svg--图片
        case 22:
        case 23:
        case 28: // svg--可编辑形状
        case 29: // svg--可编辑线条
        case "svg":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Svg",
                optionForAdd: {
                  source: item.source,
                  url: item.url,
                  resourceId: item.id, // 资源id
                  fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              "Svg",
              {
                source: item.source,
                url: item.url,
                resourceId: item.id,
                fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                effectCode: "None",
              },
              null,
              true
            ).then((sprite) => {
              sprite
                .updateEffect({
                  code: "Hand",
                  entranceAnim: {
                    hand: this.storeHand,
                  },
                })
                .then(() => {
                  this.TOOL.selectSprite([sprite]);
                });
            });
          }
          break;
        case 5: // lottie--道具
        case 8: // lottie--形状
        case 10: // lottie--角色
        case "json":
          let soundData = null,
            spriteData = {};
          if (item && item.soundFillType && item.soundUrl) {
            item.fileType = item.soundFillType;
          }

          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            if (sprite.type === "Video") {
              sprite.isLoop = sprite.video.loop;
              sprite.numberOfLoops = sprite.video.repeatTimes;
            }

            spriteData = {
              sprite,
              typeForAdd: "Lottie",
              optionForAdd: {
                lottieOptions: {
                  path: this.$handleAssetsUrl(item.url),
                  loop: 4,
                  autoplay: true, // 控制播放
                },
                resourceId: item.id, // 资源id
                fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
                characterId: item.id, // 选中那个
                isLoop:
                  typeof sprite.isLoop === "boolean"
                    ? sprite.isLoop
                    : sprite.option.isLoop,
                numberOfLoops: sprite.numberOfLoops,
              },
            };
          } else {
            spriteData = {
              lottieOptions: {
                path: this.$handleAssetsUrl(item.url),
                loop: 4,
                autoplay: true, // 控制播放
              },
              resourceId: item.id, // 资源id
              fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
              characterId: item.id, // 选中那个
              effectCode: "FadeIn",
            };
          }

          if (item && item.soundFillType && item.soundUrl) {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            soundData = {
              url: item.soundUrl,
              title: item.title,
            };

            if (this.SpriteOperation === "swap") {
              spriteData.optionForAdd.sound = soundData;
              spriteData.optionForAdd.numberOfLoops =
                sprite.numberOfLoops ||
                (sprite.option || {}).numberOfLoops ||
                3;
              spriteData.optionForAdd.lottieOptions.loop = 3;
            } else {
              spriteData.sound = soundData;
              spriteData.isLoop = true;
              spriteData.numberOfLoops = 3;
              spriteData.lottieOptions.loop = 3;
            }
          }

          if (this.SpriteOperation === "swap") {
            this.TOOL.swapSprite(spriteData, true);
          } else {
            this.TOOL.addSprite("Lottie", spriteData, null, true);
          }
          break;
        case 9: // 图表-json-形状
          _fetch(item.url)
            .then((styleRes) => {
              return styleRes.text();
            })
            .then((styleData) => {
              _fetch(item.sampleUrl)
                .then((sampleRes) => {
                  return sampleRes.text();
                })
                .then((sampleData) => {
                  this.$bus.emit("insert-chart", {
                    style: JSON.parse(styleData),
                    item: JSON.parse(sampleData),
                    resourceId: item.id,
                    fileType: item.fileType,
                    chartType: item.shapeType,
                  });
                });
            });
          break;
        case 13: // 静态素材-json-文字
          break;
        case 30: {
          // 文字组合
          const data = item;
          const runner = () => {
            return fetch(this.$handleAssetsUrl(data.url))
              .then((res) => {
                return res.json();
              })
              .then((json) => {
                let groupData = {
                  id: data.id + "," + uuid.generate(),
                  fileType: data.fileType,
                  resourceId: data.id,
                  thumbnailUrl: data.thumbnailUrl,
                };
                switch (this.boxName) {
                  case "text":
                    groupData.type = 16;
                    break;
                  case "props": // 道具
                    groupData.type = 17;
                    break;
                  case "shapes": // 形状
                    groupData.type = 15;
                    break;
                }
                let sizeW = 1920;
                let sizeH = (1920 * 9) / 16;
                let arrX = [];
                let arrY = [];
                let minX = 0;
                let minY = 0;
                json.forEach((s) => {
                  let { x, y, width, height } = s.outward;
                  let sizeX = Math.max(0, x) + width;
                  let sizeY = Math.max(0, y) + height;
                  arrX.push(sizeX);
                  arrY.push(sizeY);
                  if (x < minX) {
                    minX = x;
                  }
                  if (y < minY) {
                    minY = y;
                  }
                });
                let sizeX = Math.max.apply(null, arrX) - minX;
                let sizeY = Math.max.apply(null, arrY) - minY;

                json.forEach((s, i) => {
                  s._scale = 1 / this.TOOL.scale;
                  s.fileType -= 0;
                  s.zIndex = this.TOOL.selectedScenes.sprites.length + i;
                  // if (this.SelectScenes_Msg.duration < s.startTime * 1000) {
                  //   s.startTime = Math.floor(this.SelectScenes_Msg.duration / 1000 - 0.5)
                  // }
                  s.outward.x = s.outward.x + sizeW / 2 - sizeX / 2;
                  s.outward.y = s.outward.y + sizeH / 2 - sizeY / 2;

                  if (s.enterEffect.type === "None") {
                    s.startTime = this.SelectScenes_Msg.nowTime;
                    s.enterEffect.duration = 0;
                    s.stayEffect.duration =
                      this.SelectScenes_Msg.duration / 1000 - s.startTime;
                  } else {
                    s.startTime = this.SelectScenes_Msg.nowTime - 0.5;
                    s.enterEffect.duration = 0.5;
                    s.stayEffect.duration =
                      this.SelectScenes_Msg.duration / 1000 - s.startTime - 0.5;
                  }

                  // s.startTime = this.SelectScenes_Msg.nowTime;

                  s.exitEffect.type = "None";
                  s.exitEffect.duration = 0;
                  s.groupId = groupData;
                  // s.stayEffect.duration =  this.SelectScenes_Msg.duration / 1000 - s.startTime;
                });
                return this.SelectScenes_Msg.toFromJson(json, 1, true).then(
                  () => {
                    let sprites = this.TOOL.selectedScenes.sprites;
                    let arr = sprites.slice(-json.length);
                    let maxEnter = 0;
                    let arrS = [];
                    arr.forEach((sprite) => {
                      if (sprite.effect.entranceAnim.end > maxEnter) {
                        maxEnter = sprite.effect.entranceAnim.end;
                      }
                      if (
                        !(
                          sprite.effect.pathAnim &&
                          sprite.effect.pathAnim.target
                        )
                      ) {
                        arrS.push(sprite);
                      }
                      return arrS2;
                    });
                    this.TOOL.selectSprite(arrS);
                    eve("timeline_nowTime_change", null, {
                      nowTime: maxEnter / 1000 + 0.5,
                      noPlay: true,
                    });
                  }
                );
                return arrS;
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: "文字组合加载失败，请重试",
                });
              });
          };
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "group",
                optionForAdd: {
                  callback: runner,
                },
              },
              true
            );
          } else {
            runner();
          }
          break;
        }
        // fetch(this.$handleAssetsUrl(item.url))
        //   .then(res => {
        //     return res.json();
        //   })
        //   .then(json => {
        //     let groupData = {
        //       id: item.id + "," + uuid.generate(),
        //       fileType: item.fileType,
        //       resourceId: item.id,
        //       thumbnailUrl: item.thumbnailUrl
        //     };
        //     switch (this.boxName) {
        //       case "text":
        //         groupData.type = 16;
        //         break;
        //       case "props": // 道具
        //         groupData.type = 17;
        //         break;
        //       case "shapes": // 形状
        //         groupData.type = 15;
        //         break;
        //     }
        //     let sizeW = 1920;
        //     let sizeH = (1920 * 9) / 16;
        //     let arrX = [];
        //     let arrY = [];
        //     let minX = 0;
        //     let minY = 0;
        //     json.forEach(s => {
        //       let { x, y, width, height } = s.outward;
        //       let sizeX = Math.max(0, x) + width;
        //       let sizeY = Math.max(0, y) + height;
        //       arrX.push(sizeX);
        //       arrY.push(sizeY);
        //       if (x < minX) {
        //         minX = x;
        //       }
        //       if (y < minY) {
        //         minY = y;
        //       }
        //     });
        //     let sizeX = Math.max.apply(null, arrX) - minX;
        //     let sizeY = Math.max.apply(null, arrY) - minY;
        //     json.forEach((s, i) => {
        //       s._scale = 1 / this.TOOL.scale;
        //       s.fileType -= 0;
        //       s.zIndex = this.TOOL.selectedScenes.sprites.length + i;
        //       // if (this.SelectScenes_Msg.duration < s.startTime * 1000) {
        //       //   s.startTime = Math.floor(this.SelectScenes_Msg.duration / 1000 - 0.5)
        //       // }
        //       s.outward.x = s.outward.x + sizeW / 2 - sizeX / 2;
        //       s.outward.y = s.outward.y + sizeH / 2 - sizeY / 2;

        //       if (s.enterEffect.type === "None") {
        //         s.startTime = this.SelectScenes_Msg.nowTime;
        //         s.enterEffect.duration = 0;
        //         s.stayEffect.duration =
        //           this.SelectScenes_Msg.duration / 1000 - s.startTime;
        //       } else {
        //         s.startTime = this.SelectScenes_Msg.nowTime - 0.5;
        //         s.enterEffect.duration = 0.5;
        //         s.stayEffect.duration =
        //           this.SelectScenes_Msg.duration / 1000 - s.startTime - 0.5;
        //       }

        //       // s.startTime = this.SelectScenes_Msg.nowTime;

        //       s.exitEffect.type = "None";
        //       s.exitEffect.duration = 0;
        //       s.groupId = groupData;
        //       // s.stayEffect.duration =  this.SelectScenes_Msg.duration / 1000 - s.startTime;
        //     });
        //     this.SelectScenes_Msg.toFromJson(json, 1, true).then(() => {
        //       let sprites = this.TOOL.selectedScenes.sprites;
        //       let arr = sprites.slice(-json.length);
        //       let maxEnter = 0;
        //       let arrS = [];
        //       arr.forEach(sprite => {
        //         if (sprite.effect.entranceAnim.end > maxEnter) {
        //           maxEnter = sprite.effect.entranceAnim.end;
        //         }
        //         if (
        //           !(sprite.effect.pathAnim && sprite.effect.pathAnim.target)
        //         ) {
        //           arrS.push(sprite);
        //         }
        //       });

        //       this.TOOL.selectSprite(arrS);
        //       eve("timeline_nowTime_change", null, {
        //         nowTime: maxEnter / 1000 + 0.5,
        //         noPlay: true
        //       });
        //     });
        //   })
        //   .catch(err => {
        //     console.log(JSON.stringify(err));
        //     this.$message({
        //       type: "error",
        //       message: "文字组合加载失败，请重试"
        //     });
        //   });
        // break;
        case 35: // 相框
          if (this.loading) {
            return;
          }
          this.loading = true;
          const loadingDone = () => {
            this.loading = false;
          };
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            let optionForAdd = {
              source: item.source,
              url: item.url,
              resourceId: item.resourceId,
              fileType: item.fileType,
              picUrl: sprite.option.picUrl,
            };
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Frame",
                optionForAdd,
              },
              true
            )
              .then(loadingDone)
              .catch(loadingDone);
          } else {
            this.TOOL.addSprite(
              "Frame",
              {
                source: item.source,
                url: item.url,
                resourceId: item.id,
                fileType: item.fileType,
              },
              null,
              true
            )
              .then(loadingDone)
              .catch(loadingDone);
          }
          break;
        // 视频
        case 26:
        case 27:
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            let optionForAdd = {
              source: item.source,
              url: item.url,
              userId: item.userId,
              resourceId: item.id, // 资源id
              fileType: isNaN(item.fileType) ? null : item.fileType,
              thumbnailUrl: item.thumbnailUrl,
              video: {
                ...sprite.video,
                startTime: 0,
                cutDuration: void 0,
                volume: 50,
                poster: item.thumbnailUrl,
                loop:
                  sprite.isLoop == null
                    ? (sprite.video || {}).loop
                    : sprite.isLoop,
                repeatTimes:
                  sprite.numberOfLoops || (sprite.video || {}).repeatTimes,
              },
            };
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Video",
                optionForAdd,
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              "Video",
              {
                source: item.source,
                url: item.url,
                userId: item.userId,
                resourceId: item.id, // 资源id
                fileType: isNaN(item.fileType) ? null : item.fileType,
                thumbnailUrl: item.thumbnailUrl,
              },
              true
            );
          }
          break;
        case 42:
          let spriteType = item.url.split(".")[1];
          let itemData = item;
          itemData.soundFillType = itemData.fileType;
          delete itemData.fileType;
          itemData.soundUrl = this.$handleAssetsUrl(itemData.soundUrl);
          this.addToCanvas(itemData);
          break;
      }

      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    favoriteItem: function (item) {
      let postBody = {
        // type: 17,
        id: item.id,
      };
      if (this.classify && this.classify.originalType) {
        postBody.type = this.classify.originalType;
      } else {
        postBody.type = 17;
      }
      if (item.favorites) {
        postBody.isCancel = 1;
      }
      this.trackCollectContent({ ...item, collect_content: "道具" }, postBody);
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
          //请求的返回值中没有带收藏信息
          //所以这里做一个本地的伪处理
          if (item.favorites) {
            item.favorites = null;
            this.$bus.emit("favorites.toggle", item, false); //通知右侧列表
          } else {
            item.favorites = true;
            this.$bus.emit("favorites.toggle", item, true);
          }
        }
      });
    },
    startPreviewItem: function (item, index) {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }
      if (this.videoDom) {
        this.videoDom.pause();
      }
      this.previewTimer = setTimeout(() => {
        switch (item.fileType) {
          case 42:
            this.videoDom = this.$refs["video" + index][0];
            this.videoDom.currentTime = 0;
            this.videoDom.play();
            break;
          case 5:
          case 8:
          case 9:
            let option = {
              container: this.$refs["lottie" + index][0],
              renderer: "svg",
              loop: true,
              autoplay: false,
              path: this.$handleAssetsUrl(item.url),
            };
            this.lottiedata = lottie.loadAnimation(option);
            this.lottiedata.play();
            break;
          case 32:
          case 33:
          case 34:
            let imgDom = this.$refs["img" + index][0];
            imgDom.src = this.$handleAssetsUrl(item.url);
            break;
        }
        clearTimeout(this.previewTimer);
      }, 100);
    },
    stopPreviewItem: function (item, index) {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }
      if (this.videoDom) {
        this.videoDom.pause();
      }

      switch (item.fileType) {
        case 42:
          // let videoDom = this.$refs["video" + index][0];
          // videoDom.pause();
          break;
        case 5:
        case 8:
        case 9:
          if (this.lottiedata) {
            this.lottiedata.stop();
            this.lottiedata.destroy();
            this.lottiedata = null;
          }
          break;
        case 32:
        case 33:
        case 34:
          let imgDom = this.$refs["img" + index][0];
          imgDom.src = this.$handleAssetsUrl(item.thumbnailUrl);
          break;
      }
    },
    handleScroll(e) {
      if (this.loadingStatus != 0) {
        return;
      }
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pageIndex++;
        this.getContentList();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters([
      "StyleArrayMsg",
      "TOOL",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "SpriteOperation",
      "SpriteBeforeSwap",
      "WorksProjectId",
      "UserMsg",
    ]),
    ...mapGetters({
      storeHand: "getHand",
    }),
    showWhat(fileType) {
      if (fileType == 42) {
        return mp4;
      } else if (fileType == 35) {
        return png;
      } else {
        return png;
      }
    },
  },
  created() {
    this.sort = this.sortFlags[0];
    this.price = this.priceFlags[0];
    this.commerical = this.commericalFlags[0];
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.rootContainer {
  position: relative;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.top-bar-container {
  background-color: #fff;
  min-height: 50px;
  margin: 8px 40px 20px 40px;
  padding: 0;
  flex-shrink: 0;
}

.fixed-filter-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20px;
  //margin-top: 10px;
}

.fixed-filter-container .fixedFilter {
  margin-left: 29px;
}

.fixed-filter-container /deep/ .list-container {
  margin-left: 10px;
}

.fixed-filter-container /deep/ .list li {
  padding: 0 10px;
}

.content-container {
  // height: 525px;
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}

.content-list {
  padding: 14px 0px 0px 39px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  // overflow-y: auto;
  // height: 525px;
  width: 100%;
  flex-grow: 1;
}
.loading {
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
  //line-height: 110px;

  &>div{
    height:30px;
    line-height: 30px;
    align-self: start;
  }
}

.content-list li {
  position: relative;
  // width: 140px;
  // height: 140px;
  // background-color: #fff;
  // border-radius: 6px;
  // border: solid 1px #f0f0f8;
  // box-sizing: border-box;
  // margin-right: 25px;
  // margin-bottom: 30px;
  // overflow: hidden;

  //transition: all 0.4s;
}

.li-item-container {
  position: relative;
  width: 140px;
  height: 140px;
  background-color: #fff;
  border-radius: 6px;
  border: solid 1px #f0f0f8;
  box-sizing: border-box;
  margin-right: 25px;
  margin-bottom: 30px;
  overflow: hidden;
  transition: all 0.4s;
}

.content-list li:hover {
  .li-item-container {
    transform: scale(1.14);
  }

  .vip-logo {
    opacity: 0;
  }
  .price-style {
    opacity: 0;
  }
  .commerical-logo {
    display: none;
  }
  .addbtn {
    opacity: 1;
  }

  .lottie-cover {
    display: block;
  }

  .favorites-bg {
    display: block;
    animation: favorites-fadein 0.4s;
  }
  .logo-container {
    top: -4.56px;
    right: 18.2px;
  }
}

.static-cover {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: auto;
  transform: translate(-50%, 0);
  object-fit: contain;
  background: #fff;
}

.video-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.lottie-cover {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  object-fit: contain;
}

.addbtn {
  position: absolute;
  display: block;
  width: 88px;
  height: 28px;
  background-color: #5778fb;
  border-radius: 13px;
  left: 4px;
  bottom: 4px;
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 0;
  transition: all 0.4s;
}

.price-style {
  position: absolute;
  bottom: 4px;
  right: 4px;
  /* width: 72px; */
  height: 18px;
  padding: 0 6px;
  color: #ffffff;
  font-size: 12px;
  background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
  border-radius: 4px;
  text-align: center;

  transition: all 0.4s;
}

.logo-container {
  position: absolute;
  right: 28px;
  top: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  transition: all 0.2s;
  height: 24px;
}

.commerical-logo {
  width: 20px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/commerical.svg);
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 2px;
  // margin-right: 5px;
}

.vip-logo {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 64px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/vip-exclusive.svg);
  background-repeat: no-repeat;
  background-size: cover;

  transition: all 0.4s;
}

.company-logo {
  position: relative;
  width: 20px;
  height: 20px;
  // margin-top: 2px;
  margin-right: 4px;

  & > img {
    position: absolute;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.company-logo:hover .company-arrow-box {
  display: block;
}

.company-arrow-box {
  display: none;
  position: fixed;
  color: transparent;
  border-radius: 3px;
  width: auto;
  height: 24px;
  background-color: #000000;
  margin-left: 10px;
  margin-top: -5px;
  transform: translate(-50%, -100%);
  z-index: 100;
  & > span {
    width: 105%;
    font-size: 12px;
    color: #f8dbb2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 5px;
    text-align: left;
  }
}

.company-arrow-box:after {
  content: "";
  width: 0;
  height: 0;
  border-width: 5px;
  border-style: solid;
  border-top-color: #000000;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
}

@keyframes favorites-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.7;
  }
}

.favorites-bg {
  display: none;
  // position: absolute;
  width: 24px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  // right: 5px;
  // top: 4px;

  opacity: 0.7;
  /* transition: all 0.4s; */
}

.favorites-bg:hover {
  opacity: 1;
}

.favorites-state {
  width: 12px;
  height: 12px;
  margin-top: 4px;
  margin-left: 6px;
}

.already-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/already-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.no-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/no-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.style-layout {
  margin-left: 39px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/propsContent.vue